import React from 'react';

import routes from 'js/core_pre_webpack/routes';
import { ImpressionWatcher } from 'js/utils/impressions/ImpressionWatcher';

import NewUserDiscountButton from './NewUserDiscountButton';
import PremiumLock from './PremiumLock';
import { NavButtonWrapper, NavButtonLink } from './buttonStyles';
import { NewUserDiscount } from './types';

type PremiumButtonProps = {
  reactivate?: string;
  coupon?: string;
  newUserDiscount?: NewUserDiscount;
  trialPricingCopy?: string;
};

const PremiumButton = ({
  reactivate,
  coupon,
  newUserDiscount,
  trialPricingCopy,
}: PremiumButtonProps) => {
  let trigger = 'default';
  let url = routes.upgrade_url({
    feature: 'default',
    trigger: trigger,
    from_navbar: true,
  });
  if (trialPricingCopy) {
    trigger = 'nav-btn-trial';
    url = routes.checkout_url({
      feature: 'default',
      trigger: trigger,
      from_navbar: true,
    });
  } else if (reactivate) {
    trigger = 'nav-btn-reactivate';
    url = routes.checkout_url({
      feature: 'default',
      trigger: trigger,
      premium_discount_coupon: coupon,
      from_navbar: true,
    });
  }

  let ctaText = 'Get Premium';
  if (trialPricingCopy) {
    ctaText = trialPricingCopy;
  } else if (reactivate) {
    // TODO: DANGER: Claiming a specific discount without proof one exists
    ctaText = 'Reactivate Premium 50% OFF';
  } else if (newUserDiscount) {
    return <NewUserDiscountButton {...newUserDiscount} />;
  }

  return (
    <NavButtonWrapper>
      <ImpressionWatcher source={trigger}>
        <NavButtonLink
          href={url}
          icon={<PremiumLock circleColor="white" lockColor="blue" />}
        >
          {ctaText}
        </NavButtonLink>
      </ImpressionWatcher>
    </NavButtonWrapper>
  );
};

export default PremiumButton;
